import { useQuery } from '@tanstack/react-query';

import { getBasicUnit, getUnits } from '../api';
import { type BasicUnit, type Unit } from '../types';

export const USE_UNIT_KEY = 'useUnits';

export const USE_UNIT_IMPACT_KEY = 'useUnitsImpact';

export const useUnits = (initialData?: Unit[]) =>
  useQuery({
    queryKey: [USE_UNIT_KEY],
    queryFn: getUnits,
    staleTime: 1000 * 60 * 15,
    initialData,
  });

export const useBasicUnits = (initialData?: BasicUnit[]) =>
  useQuery({
    queryKey: [USE_UNIT_IMPACT_KEY],
    queryFn: getBasicUnit,
    staleTime: 1000 * 60 * 15,
    initialData,
  });
